import {
  OLX_ADVERT_ACTIVE_TAB_STATUSES,
  OLX_ADVERT_INACTIVE_TAB_STATUSES,
  OLX_ADVERT_PENDING_TAB_STATUSES,
  OLX_ADVERT_REJECTED_TAB_STATUSES,
  OlxAdvertStatistics,
  OlxAdvertStatus,
} from './power-olx-v2.interface';
import { PowerOlxV2Tab } from '../../../../components/tabs/enums/tabs.enum';

export interface StatusBadge {
  label: string;
  color: string;
}

export const CHECKBOX_TAB_TYPES: PowerOlxV2Tab[] = [
  PowerOlxV2Tab.ADVERTS,
  PowerOlxV2Tab.BACKUPS,
];

export const ACTIVATE_ADVERT_DISABLED_STATUSES: OlxAdvertStatus[] = [
  ...OLX_ADVERT_ACTIVE_TAB_STATUSES,
  ...OLX_ADVERT_REJECTED_TAB_STATUSES,
  ...OLX_ADVERT_PENDING_TAB_STATUSES,
];

export const DEACTIVATE_ADVERT_DISABLED_STATUSES: OlxAdvertStatus[] = [
  ...OLX_ADVERT_INACTIVE_TAB_STATUSES,
  ...OLX_ADVERT_REJECTED_TAB_STATUSES,
];

export const DELETE_ADVERT_DISABLED_STATUSES: OlxAdvertStatus[] = [
  ...OLX_ADVERT_ACTIVE_TAB_STATUSES,
  ...OLX_ADVERT_PENDING_TAB_STATUSES,
];

export enum CardItemState {
  Normal,
  Planned,
  MovedUp,
  ServicePurchased,
  Updated,
  PriceUpdated,
  AutoExtendUpdated,
  Activated,
  Deactivated,
  Duplicated,
  Restored,
  Deleted,
  StatisticsCleared,
  Error,
  Warning,
}

export const CARD_ITEM_STATE_META: Record<CardItemState, { label: string; color: string }> = {
  [CardItemState.Normal]: { label: '', color: '' },
  [CardItemState.Planned]: { label: 'planned', color: 'var(--primary-color)' },
  [CardItemState.MovedUp]: { label: 'advert_moved_up', color: 'var(--primary-color)' },
  [CardItemState.ServicePurchased]: { label: 'service_purchased', color: 'var(--primary-color)' },
  [CardItemState.Updated]: { label: 'updated', color: 'var(--primary-color)' },
  [CardItemState.PriceUpdated]: { label: 'price_updated', color: 'var(--primary-color)' },
  [CardItemState.AutoExtendUpdated]: { label: 'auto_extend_updated', color: 'var(--primary-color)' },
  [CardItemState.Activated]: { label: 'submitted_for_activation', color: 'var(--primary-color)' },
  [CardItemState.Deactivated]: { label: 'deactivated', color: 'var(--primary-color)' },
  [CardItemState.Duplicated]: { label: 'duplicated', color: 'var(--primary-color)' },
  [CardItemState.Restored]: { label: 'restored', color: 'var(--primary-color)' },
  [CardItemState.Deleted]: { label: 'deleted', color: '#000000' },
  [CardItemState.StatisticsCleared]: { label: 'statistics_cleared', color: 'var(--primary-color)' },
  [CardItemState.Error]: { label: 'error', color: '#ff0000' },
  [CardItemState.Warning]: { label: 'warning', color: 'orange' },
};

export const ADVERT_STATISTICS_ICONS_MAP: Record<keyof OlxAdvertStatistics, string> = {
  'advert_views': 'visibility',
  'phone_views': 'call',
  'users_observing': 'favorite',
};
